const envBaseUrl = String(process.env.REACT_APP_API_URL || '').trim();

const getDefaultApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location?.hostname || '';
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:5000';
    }
  }

  return '';
};

const BASE_URL = (envBaseUrl || getDefaultApiBaseUrl()).replace(/\/+$/, '');

export default BASE_URL;
